<script type="application/javascript">

export default {
    data() {
        return {
            deal: null,
            plan: null,
            checkoutOpen: false,
            busy: false,
            activePlan: null,
            showBasic: true,
            plansType: 'yearly',
            unlimitedPlan: {
                id: 'plan_unlimited_standard_v9',
                monthly: '149',
                yearly: '1340',
                monthlyOriginal: '199', // higher price monthly
                yearlyOriginal: '165', // higher price yearly
                collaborators: 'Unlimited',
                users: 'Unlimited',
                workspaces: '1',
                storage: '100',
                AutomationRunsLimit: '10,000',
                name: 'Infinity Unlimited',
                type: 'unlimited',
                includes: [
                    'Every Feature We Have',
                    'Unlimited Users for one Fixed Price',
                    'Unlimited Boards, Items and Views',
                    '10x File and Document Storage (100GB)',
                    '10,000 Automation Runs',
                ],
                includes2: [
                    '70+ Customizable Templates',
                    'Free 1h Onboarding Setup Session',
                    'First-in-line 24/7/365 Support',
                    'Dedicated Account Manager',
                ],
            },
            unlimitedAgencyPlan: {
                id: 'plan_unlimited_agency_v9',
                monthly: '349',
                yearly: '3140',
                monthlyOriginal: '499', // higher price monthly
                yearlyOriginal: '415', // higher price yearly
                collaborators: 'Unlimited',
                users: 'Unlimited',
                workspaces: '5',
                storage: '500',
                AutomationRunsLimit: '10,000',
                name: 'White Label Agency',
                type: 'unlimited',
                includes: [
                    'Every Feature We Have',
                    '5 Workspaces for Multiple Organizations',
                    'White Label and Custom Domain',
                    'Unlimited Clients & End Users',
                    'Unlimited Boards, Items and Views',
                    '50x File and Document Storage (500GB)',
                    '50,000 Automation Runs',
                ],
                includes2: [
                    'Reseller License Included',
                    '70+ Customizable Templates',
                    'Free 1h Onboarding Setup Session',
                    'First-in-line 24/7/365 Support',
                    'Dedicated Account Manager',
                    'API & Technical Support'
                ],
            },
        };
    },
    mounted() {
        this.$eventHub.$on('toggleOpenCheckout', function () {
            this.checkoutOpen = !this.checkoutOpen;
        }.bind(this));
    },
    methods: {
        openCheckout(deal) {
            // this.deal = this.plan.id;
            this.deal = deal;
            this.checkoutOpen = true;
            dataLayer.push({
                event: 'clickOpenCheckout',
                plan: this.deal.id,
                planType: this.plansType
            });
            dataLayer.push({
                event: 'clickOpenCheckoutUnlimited',
                plan: this.deal.id,
                planType: this.plansType
            });
        }
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/frontend/components/UnlimitedPricing.vue